app.directive('bootstrapCarousel', function () {
    return function (scope, element, attrs) {
        element.carousel("pause").removeData();
        element.carousel("cycle");
    };
});